<template>

  <v-container fluid class="page-content user-invite-table">

    <v-data-table
        :headers="headers"
        :items="inviteItems"
        :search="search"
        :options.sync="dataOptions"
        :footer-props="paginationOptions"
        :loading="isDataLoading"
        :server-items-length="totalItems">

      <!-- (email) -->
      <template v-slot:[`item.member_email`]="{ item }">
        <span>{{ item.member_email }}</span>
      </template>

      <!-- invited date -->
      <template v-slot:item.created_at="{ item }">
        <span>{{ formatDateTime(item.created_at) }}</span>
      </template>

      <!-- expires date -->
      <template v-slot:item.expires_at="{ item }">
        <span>{{ formatDateTime(item.expires_at) }}</span>
      </template>

      <!-- roles -->
      <!-- <template v-slot:item.member_roles="{ item }">
        <template v-if="item.member_roles && item.member_roles.length > 0">
          <v-chip v-for="role in item.member_roles"
              label
              class="mb-2 mr-2 white--text"
              :color="getRoleChipColor(role)"
              :key="role">
            {{ role }}
          </v-chip>
        </template>
      </template> -->

      <!-- (status) -->
      <template v-slot:[`item.status`]="{ item }">
        <v-chip label outlined :class="item.status" v-if="item.status">
          <span class="status-tag">{{ item.status }}</span>
        </v-chip>
      </template>
    </v-data-table>

  </v-container>

</template>

<script>

export default {
  name: 'UserInviteListDataTable',

  data () {
    return {
      headers: [
        { text: 'Email', value: 'member_email' },
        { text: 'Roles', value: 'member_roles' },
        { text: 'Invited', value: 'created_at' },
        { text: 'Expires', value: 'expires_at' },
        { text: 'Status', value: 'status' }
      ],
      isDataLoading: false,
      inviteData: null,
      dataLoadingError: null,
      paginationOptions: {
        'items-per-page-options': [10, 25, 50, 100]
      },
      dataOptions: {
        itemsPerPage: 10,
        // NOTE - Currently enabled for single field sort only !!!
        sortBy: ['last_name,first_name'],
        sortDesc: [false]
      },
      search: null
    }
  },

  computed: {
    inviteItems () {
      return (this.inviteData) ? this.inviteData.items : []
    },
    dataMeta () {
      return (this.inviteData) ? this.inviteData.meta : {}
    },
    totalItems () {
      return this.dataMeta.total_items || 0
    }
  },

  watch: {
    // Observe changes invoked by the data-table component (e.g. pagination, sorting)
    dataOptions: {
      handler () {
        this.queryData()
      },
      deep: true
    }
    // Observe changes to the search field
    // search: function (updated) {
    //   this.queryData()
    // }
  },

  methods: {
    // Refresh action to call from parent components
    refresh () {
      this.queryData()
    },

    // Display a date/time
    formatDateTime (date) {
      return (date) ? this.$root.utils.format(date, 'YYYY/MM/DD h:mm a') : ''
    },

    getRoleChipColor (role) {
      switch (role) {
        case 'owner': return 'blue'
        case 'admin': return 'amber darken-3'
        case 'dispatcher': return 'orange darken-4'
        case 'driver': return 'blue-grey lighten-1'
        case 'member': return 'blue-grey lighten-1'
        default: return 'grey'
      }
    },

    // Perform query of invites
    async queryData () {
      this.isDataLoading = true

      try {
        // Build sort
        // NOTE - Currently enabled for single field sort only !!!
        let orderBy = null
        const sortBy = this.dataOptions.sortBy
        const sortDesc = this.dataOptions.sortDesc
        if (sortBy && sortBy.length > 0) {
          const isDesc = (sortDesc && sortDesc.length > 0) ? sortDesc[0] : false
          const prefix = (isDesc) ? '-' : ''
          orderBy = `${prefix}${sortBy[0]}`
        }

        // Build pagination
        const page = this.dataOptions.page || 1
        const limit = this.dataOptions.itemsPerPage
        const skip = (page === 1) ? 0 : (page - 1) * limit

        // Build request input
        const params = {
          skip,
          limit
        }

        // Apply sorting
        if (orderBy) params.order_by = orderBy

        // console.log('[DEVING] query data:', this.dataOptions, params)

        // Retrieve results
        this.inviteData = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: 'org/invites',
          opts: { params }
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style>
  .user-invite-table .theme--dark.v-data-table {
    /* cursor: pointer; */
  }

  .user-invite-table .status-tag {
    text-transform: uppercase !important;
  }

  .user-invite-table .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .user-invite-table .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .user-invite-table .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 65px;
  }
</style>
